import { NoteIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import { useListCopy } from 'app/hooks/useListCopy'
import { labelForToken } from 'app/lib/workflows/dataContext'
import { humanizeTokens } from 'app/lib/workflows/messageFallbacks'
import type { AddNoteFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Logs a note (an Activity of type "Note") on the enrolled contact. */
export function AddNoteNode({ data, selected }: NodeProps<AddNoteFlowNode>) {
  const copy = useListCopy()
  return (
    <NodeShell
      icon={NoteIcon}
      accent="amber"
      kind="Add note"
      label={data.label}
      description={data.body.trim() ? humanizeTokens(data.body, (token) => labelForToken(token, copy)) : `No note yet`}
      selected={selected}
    />
  )
}
